import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TagListBuilder} from '@shared/helper/tag-list-builder';
import {ReserveModel} from '@app/models/reserve';
import Reserve = ReserveModel.Reserve;
import {ReservesLeisureResponse} from '@app/models/v3/reserve-leisure';

@Component({
    selector: 'app-tag-reserve-status',
    template: `
        <ng-container *ngIf="reserve">
            <p-tag styleClass="mr-2 opacity-90 shadow-4 {{styleClass}}"
                   [value]="value"
                   [severity]="severity">
            </p-tag>
        </ng-container>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagReserveStatusComponent implements OnChanges {
    @Input() reserve: Reserve | ReservesLeisureResponse;

    value: string;
    severity: string;
    styleClass: string;

    constructor() {
    }

    static builder() {
        return new TagListBuilder();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.reserve) {
            switch (this.reserve.status) {
                case 'BOOKING':
                    this.value = 'BOOKING';
                    this.severity = 'info';
                    break;
                case 'PAID':
                    this.value = 'PAID';
                    this.severity = 'success';
                    break;
                case 'SCAN':
                    this.value = 'SCAN';
                    this.severity = 'success';
                    break;
                case 'CANCEL':
                    if (this.reserve.refundAt) {
                        this.value = 'REFUNDED';
                        this.styleClass = 'bg-purple-400';
                    } else if (this.reserve.paidAt) {
                        this.value = 'CANCELED';
                        this.severity = 'danger';
                    }else if (!this.reserve.paymentData?.id) {
                        this.value = 'OBSERVE';
                        this.styleClass = 'bg-gray-500';
                    } else {
                        this.value = 'DISCARD';
                        this.styleClass = 'bg-gray-700';
                    }
                    break;
                case 'TIMEOUT':
                    this.value = 'TIMEOUT';
                    this.severity = 'warning';
                    break;
            }
        }
    }
}
